import React from "react"
import { useTranslation } from "react-i18next"

import { Button, ButtonVariant } from "shared/ui/buttons/Button"
import { IconName } from "shared/ui/icon/__generated__/IconName"

interface ModalCloseButtonProps {
  onClick: () => void
}

export const ModalCloseButton = React.memo(
  ({ onClick }: ModalCloseButtonProps) => {
    const { t } = useTranslation()
    return (
      <Button
        variant={ButtonVariant.SECONDARY}
        data-testid="close-button"
        className="modal__close-button"
        aria-label={t("General.Close")}
        onClick={onClick}
        isIconOnly
        icon={IconName.CLOSE}
      />
    )
  }
)
